const LAYER_ORDER = {
    'infrastructure-links': 0,
    'infrastructure-nodes': 1,
};

const combineLayers = (existingLayers, newLayers) => {
    const reducedLayers = existingLayers.filter(
        (existingLayer) =>
            !newLayers.some(
                (newLayer) => existingLayer.id === newLayer.id
            )
    );

    return [...reducedLayers, ...newLayers].sort((a, b) => {
        const aOrder = LAYER_ORDER[a.id] ?? 100;
        const bOrder = LAYER_ORDER[b.id] ?? 100;

        return aOrder - bOrder;
    });
};

export default combineLayers;